import { defineMachine } from "../state-machine.js";
/**
 * The product lifecycle (CAT-4, card 034). A draft goes live at once, or to review when a prohibited or export-control
 * list matches (CAT-5); a rejected review returns it to draft. Operators block and unblock; an unblocked product comes
 * back off shelf, and the seller relists it.
 */
export const productLifecycle = defineMachine({
    name: "product-lifecycle",
    states: ["draft", "pending_review", "live", "off_shelf", "blocked"],
    events: ["publish", "hold_for_review", "approve", "reject", "unlist", "relist", "block", "unblock"],
    initial: "draft",
    transitions: {
        draft: { publish: "live", hold_for_review: "pending_review" },
        pending_review: { approve: "live", reject: "draft" },
        live: { unlist: "off_shelf", block: "blocked" },
        off_shelf: { relist: "live", block: "blocked" },
        blocked: { unblock: "off_shelf" },
    },
});
/** An edit of a live product waits as a revision: applied at once, or after review when a list matches. */
export const revisionLifecycle = defineMachine({
    name: "product-revision",
    states: ["pending", "applied", "rejected"],
    events: ["apply", "reject"],
    initial: "pending",
    transitions: {
        pending: { apply: "applied", reject: "rejected" },
        applied: {},
        rejected: {},
    },
});
//# sourceMappingURL=product.machine.js.map